const SECTIONS = [
  { id: "s1", index: 1, label: "Executive Snapshot" },
  { id: "s2", index: 2, label: "Company Overview" },
  { id: "s3", index: 3, label: "Business Structure" },
  { id: "s4", index: 4, label: "Global Footprint" },
  { id: "s5", index: 5, label: "Financial Insights" },
  { id: "s6", index: 6, label: "Strategic Priorities" },
  { id: "s7", index: 7, label: "Technology Landscape" },
  { id: "s8", index: 8, label: "Competitor Landscape" },
  { id: "s9", index: 9, label: "Partnerships" },
  { id: "s10", index: 10, label: "Mergers & Acquisitions" },
  { id: "s11", index: 11, label: "Sustainability & ESG" },
  { id: "s12", index: 12, label: "Key Challenges" },
  { id: "s13", index: 13, label: "Outsourcing Landscape" },
  { id: "s14", index: 14, label: "Key Leadership" },
  { id: "s15", index: 15, label: "KPI & Performance" },
  { id: "s16", index: 16, label: "Attractiveness Score" },
  { id: "s17", index: 17, label: "Deal Opportunities" },
  { id: "s18", index: 18, label: "CXO Outreach Email" },
  { id: "s19", index: 19, label: "PPT Storyline" },
  { id: "s20", index: 20, label: "Pipeline Tracker" },
  { id: "s21", index: 21, label: "Data Confidence" },
];

export const ReportSidebar = ({ activeId }) => {
  const onClick = (e, id) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
      window.history.replaceState(null, "", `#${id}`);
    }
  };

  return (
    <nav
      className="sticky top-16 self-start h-[calc(100vh-4rem)] overflow-y-auto py-6 pr-3 no-print"
      data-testid="report-sidebar"
    >
      <div className="kpi-label mb-3 px-1">/ INDEX · 21 SECTIONS</div>
      <ul className="space-y-0.5">
        {SECTIONS.map((s) => {
          const active = activeId === s.id;
          return (
            <li key={s.id}>
              <a
                href={`#${s.id}`}
                onClick={(e) => onClick(e, s.id)}
                data-testid={`sidebar-link-${s.id}`}
                className={`flex items-baseline gap-3 px-2.5 py-1.5 rounded-sm text-[13px] transition-colors border-l-2 ${
                  active
                    ? "bg-[#1F1F1F] text-white border-[#0A84FF]"
                    : "text-[#A3A3A3] hover:text-white hover:bg-[#1F1F1F] border-transparent"
                }`}
              >
                <span className="font-mono-data text-[10px] tracking-wider text-[#525252] w-6 shrink-0">
                  {String(s.index).padStart(2, "0")}
                </span>
                <span className="truncate">{s.label}</span>
              </a>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export const SECTION_LIST = SECTIONS;
export default ReportSidebar;
